const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

//高さ調整
const tileJS = () => {
  let windowWidth = $(window).width();
  const breakPoint = 767;
  window.addEventListener('load', () => {
    if (windowWidth > breakPoint) {
      $('.js-Tile').find('.overview').tile(2);
      $('.js-Tile').find('.cast').tile(2);
      $('.js-Tile').find('.webcast').tile(2);
    } else {}
  });

  window.addEventListener('resize', () => {
    let resizeWidth = $(window).width();
    setTimeout(function() {
      if(windowWidth !== resizeWidth){
        if(resizeWidth > breakPoint){
          $('.js-Tile').find('.overview').tile(2);
          $('.js-Tile').find('.cast').tile(2);
          $('.js-Tile').find('.webcast').tile(2);
        }else{
          $('.js-Tile').find('.overview').css('height','');
          $('.js-Tile').find('.cast').css('height','');
          $('.js-Tile').find('.webcast').css('height','');
        }
      }else{}
      windowWidth = resizeWidth;
    }, 200);
  });
};
tileJS();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();


// WEBPACK FOOTER //
// ./src/assets/js/broadcast/script.js